APP.otp_init = function () {
   //clear cache 2
  // Giả lập flow để đi qua page để account demo cho KH
  $(document).on('click', '#loginSubmit', function () {
    currentPhone = $('#txtPhone').val().replace('+','');
    var sendOTPVia = $('input[name="radioReceiveOtp"]:checked').val();
    $('#txtPhone').val('');
    $('#chk_agree').prop('checked', false);
    $('#chk_age_confirmation').prop('checked', false);
    $('#receive-via-sms').prop('checked', true);

    $('.section__login').removeClass('active');
    $('.section__otp').addClass('active');
    $('#otp1').focus();
    APP.countDown();
    // Call to send OTP.    
    if(google_recapcha_enable == 1) {
        grecaptcha.ready(function () {
            grecaptcha
              .execute($("#site-key").val(), { action: "submit" })
              .then(function (token) {
                    $('#token_recaptcha').val(token);
                    APP.sendOTP(sendOTPVia);
            });
        });     
    } else {
        $('#token_recaptcha').val('');
        APP.sendOTP(sendOTPVia);
    }
  });

  // OTP Valid and set Autofocus
  $(document).on('input', '.otp__list input', function () {
    if ($(this).val().length > 1 && !$(this).hasClass('inputted')) {
      var otp = $(this).val().split('');
      for (var i = 1; i <= otp.length; i++ ) {
        $('.otp__list #otp' +i).addClass('inputted').val(otp[i-1]);
      }
    }
    if ($(this).val().length == this.maxLength) {
      $(this).addClass('inputted');
      $(this).next('input').focus();
    }

    if (APP.otpValid()) {

      // Call to check OTP.
      if (currentPhone != '') {  
        if(google_recapcha_enable == 1) {                    
            grecaptcha.ready(function () {
            grecaptcha
              .execute($("#site-key").val(), { action: "submit" })
              .then(function (token) {        
                    var remember = $('#chk_remember').prop('checked') ? '1' : '0';
                    var otp = $('#otp1').val() + $('#otp2').val() + $('#otp3').val() + $('#otp4').val();
                    var url = "/validate?_format=json&time="+ Date.now() +"&phone=" + currentPhone + "&otp=" + otp + "&nlbu=" + APP.getNlbu() + "&nlcid=" + APP.getNlcid() + '&remember=' + remember + "&token=" + token;
                    var settings = {
                      "url": url,
                      "method": "GET",
                      "timeout": 0,
                      "headers": {
                        "Content-Type": "application/json"
                      }
                    };
                    $.ajax(settings)
                    .done(function (response) {
                      // console.log('otpValid done', response);
                      if (response.data) {
                        var data = response.data;
                        window.location.reload();
                      }
                    })
                    .fail(function (response) {
                      $('.otp__list').removeClass('valided');
                      $('.otp__list').addClass('error');
                      console.log('otpValid fail', response);
                    });
                });
            }); 
        } else {
            var remember = $('#chk_remember').prop('checked') ? '1' : '0';
            var otp = $('#otp1').val() + $('#otp2').val() + $('#otp3').val() + $('#otp4').val();
            var url = "/validate?_format=json&time="+ Date.now() +"&phone=" + currentPhone + "&otp=" + otp + "&nlbu=" + APP.getNlbu() + "&nlcid=" + APP.getNlcid() + '&remember=' + remember + "&token=" + '';
            var settings = {
              "url": url,
              "method": "GET",
              "timeout": 0,
              "headers": {
                "Content-Type": "application/json"
              }
            };
            $.ajax(settings)
            .done(function (response) {
              // console.log('otpValid done', response);
              if (response.data) {
                var data = response.data;
                window.location.reload();
              }
            })
            .fail(function (response) {
              $('.otp__list').removeClass('valided');
              $('.otp__list').addClass('error');
              console.log('otpValid fail', response);
            });
        }
      }
    } else {
      $('.otp__list').removeClass('valided');
    }

  });

  $(document).on('click', '.otp__request', function () {
    if (currentPhone == '') {
      return
    }

    $('.reset__otp').trigger('click');

    APP.countDown();
    // Call to send OTP.
    APP.sendOTP('sms');
  });

  $(document).on('click', '.reset__otp', function () {
    $('.otp__list').removeClass('error');

    $('#otp1').val('');
    $('#otp2').val('');
    $('#otp3').val('');
    $('#otp4').val('');
    $('#otp1').focus();
  });
}
APP.otpValid = function() {
  if ($('#otp1').val() != '' && $('#otp2').val() != '' &&
  $('#otp3').val() != '' && $('#otp4').val() != '') {
    return true;
  }
  return false;
}
APP.sendOTP = function(sendVia = 'sms') {
  APP.loading();
  var url = "/otp?_format=json&time="+ Date.now() +"&phone=" + currentPhone + "&nlbu=" + APP.getNlbu() + "&nlcid=" + APP.getNlcid() + "&sendvia=" + sendVia + "&token=" + $('#token_recaptcha').val();


  var settings = {
    "url": url,
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json"
    },
  };

  $.ajax(settings)
    .done(function(response) {
      console.log('sendOTP done');
      APP.loading('off');
      $('#sent_otp_phone').html('+84 ' + currentPhone);
    })
    .fail(function(response) {
      response = response.responseJSON;
      if (response.spam) {

        $('.section__login').addClass('active');
        $('.section__otp').removeClass('active');

        var message = response.message;
        $('.txt__warning').html(message);
        $('.popup.otp').addClass('show');

      }
      if (response.stop) {

        $('.section__login').addClass('active');
        $('.section__otp').removeClass('active');

        var message = response.message;
        $('.txt__warning').html(message);
        $('.popup').addClass('show');

      }

      APP.loading('off');
      $('#sent_otp_phone').html('+84 ' + currentPhone);
    });
}
var intervalCountDown;

APP.countDown = function() {
    var count = 59;
    intervalCountDown = setInterval(function () {
        $(".time__count").text(count--);
        if (count == 0) {
            APP.clearIntervalCountDown();
        }
    }, 1000);
}

APP.clearIntervalCountDown = function() {
    clearInterval(intervalCountDown);
    setTimeout(function () {
        $('.otp__request').removeClass('hide');
        $('.times').addClass('hide');
        $(".time__count").text('60');
    }, 1500);
}
